module.exports = __webpack_public_path__ + "static/img/16.2d4f3de.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/5/zh/16.png
// module id = yfcD
// module chunks = 0